import { LinkIcon } from "lucide-react";

import { FunctionComponent, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import { generateLinkRoutine, setModalAddClientStatus } from "../../../store/OrganizationSlice";

import { Modal, FormField, CopyableInput } from "../../ui";

const ModalAddCLient: FunctionComponent = () => {

    const dispatch = useAppDispatch();
    const link     = useAppSelector((state) => state.organization.link);

    const [fee, setFee] = useState<number>();

    const generateLink = () => {
        if (fee) dispatch(generateLinkRoutine(fee));
    };

    const close = () => dispatch(setModalAddClientStatus(false));

    return (
        <Modal
            open
            onClose={close}
            icon={LinkIcon}
            title="Gerar link"
            subtitle="Gere um link para adicionar um cliente a sua empresa!"
        >
            <FormField
                label="Taxa"
                htmlFor="fee"
                hint="Taxa deve ser colocada em pontos. Pode ser alterada depois."
            >
                <input
                    id="fee"
                    type="number"
                    name="fee"
                    value={fee ?? ""}
                    placeholder="4"
                    onChange={(e) => setFee(Number(e.target.value))}
                />
            </FormField>

            <button className="btn-pill ghost" onClick={generateLink}>
                <LinkIcon size={14} /> Gerar link
            </button>

            {link && (
                <>
                    <hr />
                    <FormField label="Link gerado">
                        <CopyableInput value={link} />
                    </FormField>
                </>
            )}
        </Modal>
    );
};

export default ModalAddCLient;
